import { getRoleInfo } from 'utils/auth';
import { useAwardRole } from 'contexts/AwardRoleContext';
import { VALID_CATEGORIES } from 'constants/awardCategoryPillar';

export const useRoleInfo = () => {
  const contextRoleInfo = useAwardRole().roleInfo;
  const contextRoleType = contextRoleInfo.role_type || '';
  const contextPillar = contextRoleInfo.pillar || '';
  const contextCategory = contextRoleInfo.category || '';

  const hasContextData =
    contextRoleType !== '' || contextPillar !== '' || contextCategory !== '';
  const localStorageRoleInfo = getRoleInfo();

  const roleInfo = hasContextData ? contextRoleInfo : localStorageRoleInfo;
  const userRoleType = roleInfo.role_type;
  const userPillar = roleInfo.pillar;
  const userCategory = roleInfo.category;

  // Parse multiple categories for JUDGE_CATEGORY users (comma-separated)
  const userCategories = userCategory
    ? userCategory.split(',').map(c => c.trim())
    : [];
  const validUserCategories = userCategories.filter(cat =>
    VALID_CATEGORIES.includes(cat)
  );

  // Determine common role flags
  const userIsPillarPIC = userRoleType === 'PIC_PILLAR';
  const userIsSuperAdmin = userRoleType === 'AWARD_ADMIN';
  const userIsCategoryJudge = userRoleType === 'JUDGE_CATEGORY';

  return {
    roleInfo,
    userRoleType,
    userPillar,
    userCategory,
    validUserCategories,
    userIsPillarPIC,
    userIsSuperAdmin,
    userIsCategoryJudge,
  };
};
